(ns hypnos.dme.tile.field.referral-key
  "Field for the (external) patient key."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/patient-key)]]
    [:div.field-body
     [:div.field
      [:p.control.is-expanded
       [:input.input
        {:type        :text
         :disabled    disabled
         :placeholder (when-not disabled (tr :ui.placeholder/patient-key))
         :value       (get-in @state [:patient :patient/key :value])
         :on-change   (fn [e]
                        (let [old-value (get-in @state [:patient :patient/key :value])
                              new-value (-> e .-target .-value)
                              changed?  (or (get-in @state [:patient :patient/key :dirty?])
                                            (not= new-value old-value))]
                          (swap! state assoc-in [:patient :patient/key :value] new-value)
                          (swap! state assoc-in [:patient :patient/key :dirty?] changed?)))
         :on-blur     (fn [_]
                        (swap! state assoc-in
                               [:patient :patient/key :touched?]
                               true))}]]
      (when-not disabled [:p.help (tr :ui.help/patient-key)])]]]))
